import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import ServicesPreview from '../components/ServicesPreview';
import WhyChooseUs from '../components/WhyChooseUs';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <Stats />
      <ServicesPreview />
      <WhyChooseUs />
      <CTA />
    </div>
  );
};

export default Home;